/* eslint-disable complexity */
import { Grid } from '@mui/material'
import React, { FC, useCallback, useContext } from 'react'
import { useNavigate } from 'react-router-dom'

import { AppRoutes } from '../../models'
import { NewAppointmentContext } from '../../providers'
import { AppointmentPanel } from '../AppointmentPanel'
import { NewAppointmentContainer } from './NewAppointmentContainer'

export const AppointmentContainer: FC = () => {
  const navigate = useNavigate()
  const { openPanel, setOpenPanel, selectedAppointment } = useContext(
    NewAppointmentContext
  )

  const submitCallBack = useCallback(async () => {
    setOpenPanel(false)
    navigate(`${AppRoutes.APPOINTMENTS}`, { replace: true })
  }, [navigate, setOpenPanel])
  return (
    <>
      {openPanel && (
        <Grid item xs={4}>
          {selectedAppointment?.id === 'new' && <NewAppointmentContainer />}
          {selectedAppointment && selectedAppointment.id !== 'new' && (
            <AppointmentPanel
              appointment={selectedAppointment}
              submitCallBack={submitCallBack}
              cancelCallBack={() => setOpenPanel(false)}
              deleteCallBack={submitCallBack}
            />
          )}
        </Grid>
      )}
    </>
  )
}
